import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItem {
  question: string;
  answer: string;
}
export const SuperfoodsFAQSection: React.FC = () => {
  const [openItem, setOpenItem] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenItem(openItem === index ? null : index);
  };
  const faqItems: FAQItem[] = [{
    question: 'Mohu kombinovat trénink a zelené potraviny?',
    answer: 'Rozhodně ano. To je právě ta nejsilnější kombinace. Každý z těchto prvků podporuje jinou část těla i mysli – a dohromady tvoří systém, který funguje.'
  }, {
    question: 'Na jak dlouho mi vydrží jeden balíček superpotravin?',
    answer: 'To je individuální, jelikož počet který se bere například chloreli, tak se odvodí od Vaši váhy. Ale samozřejmě, nezačnete hned od začátku brát, plné dávky. Proč? Protože superpotraviny mají detoxikační učinky, a dávky se musí postupně zvedat. Pokud někoho tělo je opravdu zakyselené, tak to může mít i efekt takový, že Vám bude trochu divně od břicha, ale nebojte tenhle pocit je úplně normální, a pokud si tímhle pocitem procházíte, tak víte, že superpotraviny fungují. Po maximálně 3 dnech už by Vám mělo být líp.'
  }, {
    question: 'Jsou produkty vhodné i pro ženy?',
    answer: 'Ano – plány i doplňky jsou vhodné pro ženy i muže.'
  }, {
    question: 'Chci jen tréninkový plán. Musím kupovat i doplňky?',
    answer: 'Nemusíš. Ale doporučuji to, pokud chceš výsledky rychleji, bezpečněji a udržitelně. Trénink je základ. Ale výživa a regenerace dělají tvůj posun ještě větší.'
  }, {
    question: 'Chci spolupracovat s GW– jak to funguje?',
    answer: 'Nejdřív si udělej vlastní zkušenost – objednej si zelené potraviny. Až budeš mít vlastní výsledky, můžeme probrat spolupráci. Tohle není síťovka pro prodejce. Je to o pomoci lidem a budování hodnoty.'
  }, {
    question: 'Proč bych měl začít užívat superpotraviny preventivně, i když momentálně nemám žádné zdravotní problémy?',
    answer: 'Superpotraviny nejen podporují růst svalů, regeneraci a další procesy, které vedou k rychlejšímu progresu, ale zároveň fungují i preventivně. To znamená, že i když teď nemáš žádné zdravotní problémy, tvoje tělo z nich může těžit a dlouhodobě posilovat svou odolnost.\n\nMožná si říkáš, že žádné problémy teď nemáš, ale to neznamená, že tvoje tělo nic nepotřebuje – jen ti zatím neposílá varovné signály. Většina lidí z Green Ways, kteří si prošli změnou, by dala všechno proto, aby mohla začít brát superpotraviny už preventivně, dřív než problémy nastaly.\n\nTo je i důvod, proč jsem začal podnikat s Green Ways – nejen že je to skvělý nástroj pro urychlení progresu v posilovně, ale zároveň funguje jako preventivní potravina pro tělo. Vyživuje a dodává živiny, které jsou nezbytné pro zdravé fungování. Většina mladých lidí neřeší své zdraví, dokud nemají problémy – a právě proto chci dostat superpotraviny mezi co nejvíc mladých lidí, aby se nemocem předcházelo, místo aby se řešily až tehdy, když nastanou.'
  }, {
    question: 'V čem je Green Ways komunita výjimečná?',
    answer: 'Green Ways komunita sdružuje lidi, kteří odmítají jít stejným směrem jako většina společnosti, pokud jde o zdraví.\n\nNechtějí čekat, až se objeví problémy, aby pak spoléhali na léky, které sice vyřeší jeden problém, ale často přinesou jiný.\n\nTahle komunita se rozhodla jít proti proudu – vědomě, přirozeně a s důrazem na dlouhodobé zdraví, ne na rychlé náplasti.\n\nGreen Ways jako firma funguje už více než 25 let a investuje obrovské prostředky do pozemků na těch nejlepších místech pro pěstování nejkvalitnější chlorelly a ječmene na trhu.\n\nNa stránkách najdeš stovky příběhů lidí, kteří sdíleli svou proměnu a popsali, jak jim to změnilo život.\n\nGreen Ways spojuje lidi, kteří věří, že tělo má neuvěřitelnou schopnost uzdravovat se, když mu dáme to, co opravdu potřebuje. A právě tahle víra spolu s kvalitou a výsledky dělá komunitu Green Ways výjimečnou.'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="mt-16 max-w-4xl mx-auto" data-id="element-763">

      <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl p-6 md:p-10 luxury-card border border-green-500/30 shadow-[0_10px_40px_-5px_rgba(34,197,94,0.2)] relative overflow-hidden" data-id="element-764">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-765"></div>
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-766"></div>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-green-500/5 rounded-full filter blur-3xl" data-id="element-767"></div>

        <h4 className="text-2xl md:text-3xl font-bold mb-3 text-center relative" data-id="element-768">
          <span className="relative inline-block" data-id="element-769">
            <span className="relative z-10" data-id="element-770">
              FAQ - <span className="text-green-500" data-id="element-771">Časté otázky</span>
            </span>
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500 to-transparent" data-id="element-772"></span>
          </span>
        </h4>

        <p className="text-center text-gray-400 text-sm md:text-base mb-8 font-light tracking-wide" data-id="element-773">
          (doporučuji si projít průvodce superpotravinami)
        </p>

        <div className="space-y-4" data-id="element-774">
          {faqItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="bg-black/30 rounded-lg border border-green-500/20 overflow-hidden hover:border-green-500/40 transition-all duration-300" data-id="element-775">

              <button onClick={() => toggleItem(index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-green-500/5 transition-colors duration-300" data-id="element-776">

                <span className="text-base md:text-lg font-medium text-white pr-4" data-id="element-777">
                  {item.question}
                </span>
                <motion.div animate={{
              rotate: openItem === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-778">

                  <ChevronDownIcon className="w-5 h-5 text-green-500" data-id="element-779" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-780">
                {openItem === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-781">

                    <div className="px-6 pb-4 pt-2" data-id="element-782">
                      <div className="text-sm md:text-base text-gray-300 leading-relaxed whitespace-pre-line" data-id="element-783">
                        {item.answer}
                      </div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
};